import { stimuliBackendBaseUrl } from '../stimuli/stimulusUploads';

const CONTROL_SLIDE_UPLOAD_TIMEOUT_MS = 120000;

function backendBaseUrl(baseUrl) {
  return (baseUrl || stimuliBackendBaseUrl()).replace(/\/+$/, '');
}

function responseDetail(response, fallback) {
  const detail = response && typeof response === 'object' ? response.detail : null;
  return typeof detail === 'string' && detail ? detail : fallback;
}

export function createControlSlide({
  baseUrl,
  token,
  organizationId,
  controlIdentifier,
  description,
  files,
  onProgress,
}) {
  return new Promise((resolve, reject) => {
    const body = new FormData();
    body.append('organization_id', organizationId);
    body.append('control_identifier', String(controlIdentifier));
    body.append('description', String(description || '').trim());
    Array.from(files || []).forEach((file) => body.append('files', file, file.name));

    const request = new XMLHttpRequest();
    request.open('POST', `${backendBaseUrl(baseUrl)}/admin/control-slides`);
    request.setRequestHeader('Authorization', `Bearer ${token}`);
    request.responseType = 'json';
    request.timeout = CONTROL_SLIDE_UPLOAD_TIMEOUT_MS;
    request.upload.onprogress = (event) => {
      if (event.lengthComputable && onProgress) {
        onProgress(Math.round((event.loaded / event.total) * 100));
      }
    };
    request.onload = () => {
      if (request.status >= 200 && request.status < 300) {
        resolve(request.response || {});
        return;
      }
      reject(new Error(responseDetail(
        request.response,
        `Control slide creation failed (HTTP ${request.status}).`,
      )));
    };
    request.onerror = () => reject(new Error('Network error while creating the control slide.'));
    request.ontimeout = () => reject(new Error('Control slide upload timed out.'));
    request.send(body);
  });
}

export async function updateControlSlideState({
  baseUrl,
  token,
  organizationId,
  controlIdentifier,
  enabled,
  fetchImpl = globalThis.fetch,
}) {
  const response = await fetchImpl(
    `${backendBaseUrl(baseUrl)}/admin/control-slides/${controlIdentifier}`,
    {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ organization_id: organizationId, enabled }),
    },
  );
  let body = {};
  try {
    body = await response.json();
  } catch (_error) {
    body = {};
  }
  if (!response.ok) {
    throw new Error(responseDetail(body, `Control slide update failed (HTTP ${response.status}).`));
  }
  return body;
}
